import React, { Component } from "react";
import Header from "../header";
import Vendor from "./Vendor";
class OtherVendors extends Component {
  render() {
    const { vendors, handleVendorList, selectedVariant } = this.props;
    return (
      <div className="vendorsList">
        <Header
          showSearchBar={true}
          title={"لیست کامل فروشندگان "}
          backHandler={() => {
            handleVendorList(false);
          }}
        />
        {vendors
          .filter(
            (v) =>
              v.variant_id === (selectedVariant !== 0 ? selectedVariant : null),
          )
          ?.map((vendor) => (
            <Vendor vendor={vendor} />
          ))}
      </div>
    );
  }
}
export default OtherVendors;
